const MANAGEMENT_TABS = [
  "details",
  "sales",
  "clients",
  "transactions",
  "analytics",
  "automation",
  "settings",
] as const;

const PAID_ONLY_TABS: ReadonlySet<string> = new Set(["sales", "transactions", "analytics"]);

/**
 * Tabs that used to be top level and now live as a sub-tab elsewhere. Bookmarks and
 * links shared before the split still resolve instead of bouncing to the details tab.
 */
const MOVED_TABS: Readonly<Record<string, string>> = {
  installments: "analytics",
};

interface ProductTabsAccess {
  canManageProducts: boolean;
  canReadResources: boolean;
  isFree: boolean;
}

export const getAvailableProductTabs = ({
  canManageProducts,
  canReadResources,
  isFree,
}: ProductTabsAccess): string[] => {
  if (!canManageProducts) {
    return canReadResources ? ["resources"] : [];
  }

  const managementTabs = isFree ? MANAGEMENT_TABS.filter((tab) => !PAID_ONLY_TABS.has(tab)) : [...MANAGEMENT_TABS];

  return [...managementTabs, "resources"];
};

export const getDefaultProductTab = (canManageProducts: boolean): string =>
  canManageProducts ? "details" : "resources";

/** The tab a URL should land on: itself when still available, its new home when it moved. */
export const resolveProductTab = (tab: string, availableTabs: string[]): string | null => {
  if (availableTabs.includes(tab)) {
    return tab;
  }

  const movedTo = MOVED_TABS[tab];

  return movedTo && availableTabs.includes(movedTo) ? movedTo : null;
};
